// extracted by mini-css-extract-plugin
export default {"spinner":"navStyle_spinner__5+5ZP","lds-spinner":"navStyle_lds-spinner__bYAje","vote":"navStyle_vote__moujf","footer":"navStyle_footer__ugRhA","navbar":"navStyle_navbar__JOmPn"};